import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Pipe({
  name: 'currency',
  standalone: true
})
export class CurrencyPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: any, args?: any): string {

    let currency;

    if (args)
    currency = this.translate.instant('common.currency');

    return value.toLocaleString('en-IN') + " " + currency;

  }
}
